const EFFICIENCE_APP_URL = process.env.REACT_APP_EFFICIENCE_APP_URL ?? ''

export { EFFICIENCE_APP_URL }
